<template>
  <div class="loginInputWrapper">
    <small>{{spanText}}</small>
    <div class="loginInputTextWrapper">
      <input v-bind:type="isPassword ? 'password' : 'text'" v-bind:placeholder="placeHolder" v-on:keyup="returnText" v-on:keyup.enter="pressEnterKey"/>
      <div class="inputButton" v-on:click="sendVerifyEmail">
        <span>{{buttonValue}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spanText: String,
    placeHolder: String,
    isPassword: Boolean,
    buttonValue: String
  },
  data () {
    return {
      text: null
    }
  },
  methods: {
    returnText: function (e) {
      this.text = e.target.value
      this.$emit('returnText', e.target.value)
    },
    pressEnterKey: function () {
      this.$emit('pressEnterKey')
    },
    sendVerifyEmail: function () {
      this.$emit('sendVerifyEmail', this.text)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
small{
  color: rgb(0,153,255);
}

.loginInputWrapper{
  font-size: 11px;
  margin-top: 25px;
}

.loginInputTextWrapper{
  display: flex;
  display: -ms-flexbox;
  justify-content: space-between;
  align-items: flex-end;
  width: 400px;
  padding-top: 10px;
  padding-bottom: 10px;
}

input[type='text'], input[type='password'] {
  padding-bottom: 5px;
  font-size: 18px;
  width: 252px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
}

input[type='text']:focus, input[type='password']:focus{
  outline: none;
}

.inputButton {
  cursor: pointer;
  width: 104px;
  height: 40px;
  border: 2px solid black;
  font-size: 13px;
  text-align: center;
}

.inputButton > span {
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/elements/loginInputTextAndButton.vue